export default __webpack_public_path__ + "static/media/games2.eff7bf69.png";